export default __webpack_public_path__ + "static/media/airbnb2.2662c5da.jpg";